import styled from "styled-components/macro";
import {
  TILE_WIDTH_PX_SM,
  repeatAutoFit,
  GRID_GAP,
} from "../../../../constants/constants";

export const GroupTilesPanelStyles = styled.div<{
  $tileWidth: number;
  $tileWidthConfig: number;
  $isLargeTiles: boolean;
}>`
  /* https://stackoverflow.com/questions/20541306/how-to-write-a-css-hack-for-ie-11 */
  @media all and (-ms-high-contrast: none) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-items: left;
    align-content: start;
  }
  @supports (display: grid) {
    display: grid;
    grid-template-columns: ${props =>
      props.$isLargeTiles
        ? repeatAutoFit(props.$tileWidth)
        : repeatAutoFit((props.$tileWidthConfig ?? 1) * TILE_WIDTH_PX_SM)};
    grid-template-rows: ${props =>
      props.$isLargeTiles
        ? repeatAutoFit(props.$tileWidth)
        : repeatAutoFit(TILE_WIDTH_PX_SM)};
    grid-gap: ${GRID_GAP / 2}px;
    justify-items: center;
  }
  justify-content: center;
  margin-top: 1em;
  margin-bottom: 1em;
  .group-tile {
    font-family: "Open Sans", sans-serif !important;
    box-sizing: border-box;
  }
  a {
    text-decoration: none;
  }
  .tile-container {
    position: relative;
  }
`;
